import React from "react";
import { Box, Typography } from "@material-ui/core";


const UserAndDate = ({ username, date, variant, separator }) => {

  let usernameLabel = '-'
  let dateLabel = '-'

  if (username) {
    usernameLabel = username;
  } 
  if (date) {
    dateLabel = date;
  } 

  return (
    <Box alignItems="center" display="block">
      <Typography variant={variant?variant:'body2'}>{usernameLabel}</Typography>
      <Typography variant={variant?variant:'caption'}>{dateLabel}</Typography>
    </Box>
  );
};

export default UserAndDate;
